import { Injectable } from '@angular/core';
import { HttpRequestService } from './http-request.service';

@Injectable({
  providedIn: 'root'
})
export class StagesService {

  constructor(private httpRes: HttpRequestService) { }

  GetStages()
  {
    return this.httpRes.GetRequest(`Stages/GetStages`);
  }

  // get patient stages.
  GetPatientStages(PatientUserId: string)
  {
    return this.httpRes.GetRequest(`Stages/GetPatientStages/${PatientUserId}`);
  }

  // get Stage Instructions.
  GetStageInstructions(StageId: number)
  {
    return this.httpRes.GetRequest(`Stages/GetStageInstructions/${StageId}`);
  }


}
